<template>
  <main class="home">
    <section id="intro" v-html="home.text"></section>
    <info></info>
    <programm></programm>
    <curators></curators>
    <partners></partners>
    <section id="tickets" v-if="festival.tickets.length > 0">
      <h1>Tickets</h1>
      <div class="aha-tickets">
        <a :href="festival.tickets" target="_blank" v-html="festival.tickettxt">
        </a>
      </div>
    </section>
    <kontakt></kontakt>
  </main>
</template>

<script>
import Programm from './ProgrammAll.vue'
import Info from './Info.vue'
import Curators from './Kuratorium.vue'
import Partners from './Partners.vue'
import Kontakt from './Kontakt.vue'

export default {
  name: 'home',
  components: {
    Programm,
    Info,
    Curators,
    Partners,
    Kontakt
  },
  computed: {
    home () {
      return this.$store.getters.getPageByUID('home')
    },
    festival () {
      return this.$store.getters.getPageByUID('festival')
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';

</style>
